// 默认占位图片路径
const DEFAULT_PLACEHOLDER = '/img/eva.png';

// 图片类型映射
const IMAGE_TYPE_MAP: { [key: string]: string } = {
  'avatar': '/img/eva.png',
  'user': '/img/Rectangle 1092.png',
  'social': '/img/facebook.svg'
};

/**
 * 获取图片URL
 * @param path 图片路径
 * @param type 图片类型（可选）
 * @returns 处理后的图片URL
 */
export const getImageUrl = (path: string, type?: string): string => {
  try {
    // 如果是完整的URL，直接返回
    if (path.startsWith('http') || path.startsWith('data:')) {
      return path;
    }

    // 移除开头的点和斜杠，并确保以斜杠开头
    const normalizedPath = '/' + path.replace(/^\.\/|\//, '').replace(/^\/+/, '');
    
    // 如果路径无效或图片不存在，使用降级策略
    if (!normalizedPath || normalizedPath === '/') {
      return type && IMAGE_TYPE_MAP[type] ? IMAGE_TYPE_MAP[type] : DEFAULT_PLACEHOLDER;
    }

    // 构建完整的图片URL，确保路径正确
    // 移除路径中的相对路径标记，确保图片能正确加载
    return normalizedPath.startsWith('/') ? normalizedPath : `/${normalizedPath}`;
  } catch (error) {
    console.error('图片路径处理错误:', error);
    // 使用类型对应的占位图或默认占位图
    return type && IMAGE_TYPE_MAP[type] ? IMAGE_TYPE_MAP[type] : DEFAULT_PLACEHOLDER;
  }
};